export default "__VITE_ASSET__d2b45955__"